import React, { Component } from 'react';
import {lstorage} from 'utils/lstorage.js';
import Dropdown from 'react-dropdown';
import { connect } from "react-redux";

class AudioInputChooser extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: [],
        };

        this.getOptions();
    }

    async getOptions() {
        if (navigator.mediaDevices === undefined) {
            return;
        }
        let devices = await navigator.mediaDevices.enumerateDevices();
        let options = devices
            .filter(deviceInfo => deviceInfo.kind === 'audioinput')
            .map(
            device =>
                ({label:  device.label, value: device.deviceId}));

        if (this.props.deviceId !== undefined) {
        } else {
            let defaultInputType = this.props.defaultInput || 'default';
            let defaultInput = devices.filter(deviceInfo => deviceInfo.label.includes(defaultInputType));
            if (defaultInput.length > 0 && this.props.audioInputSource === undefined) {
                this.onChangeInput(defaultInput[0].deviceId);
            }
        }

        this.setState({options: options});
    }

    getOption(val) {
        if (val === undefined) {
            val = 'default';
        }
        return this.state.options
            .filter(opt => opt.value === val)[0];
    }

    async onChangeInput(input) {
        let stream = await navigator.mediaDevices.getUserMedia({
            audio: {deviceId: input, echoCancellation : false}
        });

        lstorage.setItem('deviceId', input);
        console.log("choosing stream=", stream, input);
        this.props.onChooseAudio(stream, input);
    }

    render() {
        let className = this.props.defaultClassName || "audio-input-chooser";
        return (
            <div className={className}>
              <div className="dropdown-title">
                Input Device:
              </div>
                <Dropdown
                  className='audio-input-chooser-dropdown'
                  controlClassName='audio-input-chooser-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={this.state.options}
                  onChange={(o) => this.onChangeInput(o.value)}
                  value={this.getOption(this.props.deviceId)}
                  placeholder="Audio Input" />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
    };
};
const mapStateToProps = state => {
    return {
        audioInputSource: state.sequencer.audioInputSource,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioInputChooser);
